import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition } from '../../models';
import { ILoggerService } from '../../services';
import { MixedUserChoice } from '../../models/mailing/MixedUserChoice';

class MixedUserMultiSelectController implements angular.IComponentController {
    selectedChoices: MixedUserChoice[];
    
    readonly choices: MixedUserChoice[];
    readonly formController: angular.IFormController;

    static $inject = ['$translate', 'loggerService'];
    constructor(private _$translate: angular.translate.ITranslateService,
        private _loggerService: ILoggerService) {
    }

    addChoice(data: { itemId: string }) {       
        const id = data.itemId.replace('id', '');
        const choice = _.find(this.choices, c => c.originalObject.id === id || c.originalObject.userId === id
            || (c.originalObject !== undefined && c.originalObject.toString() === id));
        if (choice) {
            if (this.selectedChoices.indexOf(choice) >= 0) {
                this._loggerService.logWarning(this._$translate.instant('Duplicate entry'));
            } else {
                this.selectedChoices.push(choice);
                if(this.formController){
                    this.formController.$setDirty();
                }
            }
        }
    }
}

export const wtMixedUserMultiSelect: ComponentDefinition = {
    componentId: 'wtMixedUserMultiSelect',
    controller: MixedUserMultiSelectController,
    template: require('./mixedUserMultiSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        choices: '<',
        formController: '<?',
        selectedChoices: '='
    }
};
